import { C_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";

export interface I_OwnersForm {
  identification_type: I_GENERIC_ITEMS[];
  number_identification: string;
  name: string;
  birthdate: string;
  country: I_GENERIC_ITEMS[];
  city: string;
  sector: string;
  address: string;
  mobile_phone: string;
  phone: string;
  residential_phone: string;
  email: string;
  fax: string;
  has_company: I_GENERIC_ITEMS[];
  company: string;
  company_phone: string;
  company_occupation: string;
  company_identification: string;
  company_email: string;
  company_registration_comercial: string;
  company_fax: string;
  is_conflictive?: number;
  new?: boolean;
}

const initialCreateOwnersFormState: I_OwnersForm = {
  identification_type: [],
  number_identification: "",
  name: "",
  country: [],
  city: "",
  sector: "",
  birthdate: "",
  address: "",
  mobile_phone: "",
  phone: "",
  residential_phone: "",
  email: "",
  fax: "",
  has_company: [C_YES_AND_NOT.NOT],
  company: "",
  company_occupation: "",
  company_identification: "",
  company_email: "",
  company_registration_comercial: "",
  company_fax: "",
  company_phone: "",
  new: true
};

export { initialCreateOwnersFormState as initialCreateOwnersFormState };

function generateEnumsFromKeys<T extends Record<string, any>>(obj: T) {
  return Object.keys(obj).reduce((enums: any, key) => {
    enums[key] = key;
    return enums;
  }, {} as Record<keyof T, string>);
}

const CreateOwnersFormEnums: Record<keyof I_OwnersForm, string> =
  generateEnumsFromKeys(initialCreateOwnersFormState);

export { CreateOwnersFormEnums };
